import type { ReactNode } from "react";
import { Link } from "@knowtex-ai/components";

/** A link opened in a new tab so the current page keeps its place: `to` another MC page, or `href` elsewhere. */
export default function NewTabLink({
  to,
  href,
  children,
  size,
  className,
  "aria-label": ariaLabel,
}: {
  children: ReactNode;
  size?: "inherit" | "large" | "medium" | "small";
  className?: string;
  "aria-label"?: string;
} & ({ to: string; href?: never } | { href: string; to?: never })) {
  return (
    <Link
      {...(href ? { href } : { to: to! })}
      newTab
      size={size}
      className={className}
      aria-label={ariaLabel && `${ariaLabel} (opens in a new tab)`}
    >
      {children}
      {!ariaLabel && <span className="sr-only"> (opens in a new tab)</span>}
    </Link>
  );
}
